import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icon, Tooltip } from 'antd';
import {
  Container,
  TabsContainer,
  TabDetails,
  TabIcon,
  TabsActivityContainer,
  TabsActivityHighlighter,
  TabExpandContainer,
  SidebarCloseMenu,
  SideBarContent,
  TemplateName,
  Logo,
  AppLogo,
  MenuTabs,
  VariableCounter,
} from '../../../containers/SidebarMenu/styles';
import { MessageStudioLogo } from '../../SidebarMenuIcons';
import ShortMessageTemplates from './ShortMessageTemplates';
import SettingsTabDetails from '../../../containers/SidebarMenu/SettingsTabDetails';
import TranslateMessages from './TranslateMessage';
import DocumentName from '../../DocumentName';
import ExitIcon from '../../../images/exit.svg';
import { AppStoreContext } from '../../../context/appStoreContext';
import { getAllLanguage } from '../../../utils/services/languageApi';
import { TabDetailsMeta } from '../../../containers/SidebarMenu/tabIndexConstants';
import VariablesList from '../../../artboard/VariablesList';
import _ from 'underscore';
import { useTranslation } from 'react-i18next';
import { SHORT_MESSAGE_TRANSLATE_TAB } from './translationValues';
import ChannelTab from '../../../containers/ComplexDocumentDesign/ChannelTab/CommunicationTab';
import { changeTemplateName, updateCommunicationName } from '../../../utils/services/shortMessageTemplateAPI';

/* This component contains short messages sibe bar menu items
  Child Components: 
    * DocumentName
    * ShortMessageTemplates
    * TranslateMessages
    * VariablesList
    * SettingsTabDetails
*/
const NAMESPACES = ['SHORT_MESSAGE_TRANSLATE_TAB'];
class SidebarMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isBottom: false,
      allLanguages: [],
      activeTabPosY: '',
    };
    this.scrollRef = React.createRef();
  }

  static contextType = AppStoreContext;

  async componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    let response = await getAllLanguage();
    if (response?.data && response?.statusCode === 109) {
      this.setState({ allLanguages: response.data });
      this.context.setLanguageList(response?.data);
    }
  }
  componentDidUpdate() {
    this.activeTabPosition(this.props?.tabIndex && this.props?.tabIndex);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const { activeTabPosY } = this.state;
    const { tabIndex } = this.props;
    if (tabIndex >= 0 && window.innerHeight !== activeTabPosY) {
      this.activeTabPosition(tabIndex);
    }
  };
  activeTabPosition = index => {
    let posY = 0;
    if (index !== null && index !== undefined) {
      posY =
        index >= 0 ? document.querySelector(`#sideBar${index}`)?.getBoundingClientRect().top : 0;
    }
    this.setState({ activeTabPosY: posY });
  };

  changeTemplateName = value => {
    // TODO : Know communication id
    updateCommunicationName(this.props.communicationId, value);
    this.props.templateName(value);
  };

  onScroll = e => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (scrollTop + clientHeight === scrollHeight) {
      this.setState({ isBottom: true });
    } else {
      this.setState({ isBottom: false });
    }
  };

  scrollToTop = () => {
    this.scrollRef.current.scrollTo(0, 0);
  };

  render() {
    const {
      t,
      tabIndex,
      template,
      templateDisplayName,
      templateId,
      groupId,
      communicationId,
      language,
      categoryId,
      resourceGroupId,
    } = this.props;
    const { isBottom, allLanguages, activeTabPosY } = this.state;
    const {
      userDetails,
    } = this.context;
    const SideBarTabsList = TabDetailsMeta(t);
    const tabs = SideBarTabsList.filter(tab =>
      this.props.availableTabs.includes(tab.id),
    ).filter(tab => (tab.enable ? tab.enable(userDetails.userType) : true));
    const highLightIndex = tabs.findIndex(tab => tab.id === tabIndex);
    return (
      <Container display={1}>
        <div className={'messageDesign'}>
          <Logo messageStudio={true}>
            <Link to={'/shortMessageTemplates'}>
              <AppLogo style={{ marginTop: '-15px' }}>
                <Icon component={MessageStudioLogo} />
              </AppLogo>
            </Link>
            <div className="name">{t(SHORT_MESSAGE_TRANSLATE_TAB.MESSAGE_STUDIO_LABEL.key, SHORT_MESSAGE_TRANSLATE_TAB.MESSAGE_STUDIO_LABEL.value)}</div>
          </Logo>
          <MenuTabs>
            {tabIndex >= 0 && (
              <TabsActivityContainer>
                <TabsActivityHighlighter
                  style={{ transform: `translate3d(0px, ${activeTabPosY}px, 0px)` }}
                  tabIndex={highLightIndex}
                ></TabsActivityHighlighter>
              </TabsActivityContainer>
            )}
            <TabsContainer>
              {tabs.map(tab => (
                <TabDetails
                  id={`sideBar${tab.id}`}
                  onClick={() => {
                    this.activeTabPosition(tab.id);
                    this.props.tabClickHandler(tab.id);
                  }}
                  active={tabIndex === tab.id}
                  key={tab.id}
                >
                  <Tooltip placement="right" title={tab.label}>
                    <TabIcon className={tabIndex === tab.id && 'activeTab'}>
                      <Icon
                        component={tab.icon}
                        type={tab.type}
                        className={tab.className}
                        style={{ color: '#fff' }}
                      />
                    </TabIcon>
                  </Tooltip>
                  {tab.id === 9 && (
                    <AppStoreContext.Consumer>
                      {appStoreContext => {
                        let uniqueList = _.unique(
                          appStoreContext.documentVariables,
                          variable => variable.variableId,
                        );
                        if (uniqueList.length > 0) {
                          return (
                            <VariableCounter>
                              <span className="docVarCount">{uniqueList.length}</span>
                            </VariableCounter>
                          );
                        }
                      }}
                    </AppStoreContext.Consumer>
                  )}
                </TabDetails>
              ))}
            </TabsContainer>
          </MenuTabs>
        </div>
        <SideBarContent>
          <TemplateName>
            <DocumentName
              disabled={false}
              templateName={templateDisplayName}
              changeTemplateName={this.changeTemplateName}
              isElement={false}
              onBlur={() => this.props.templateName(templateDisplayName)}
            />
          </TemplateName>
          <TabExpandContainer
            onScroll={this.onScroll}
            disable={false}
            ref={this.scrollRef}
            className={
              tabIndex >= 0 && (tabIndex === 9 || tabIndex === 10)
                ? 'variables'
                : tabIndex >= 0
                ? 'showSideBar'
                : 'hideSideBar'
            }
          >
            {tabIndex >= 0 && (
              <SidebarCloseMenu onClick={() => this.props.tabClickHandler(-1)}>
                <Tooltip placement="right" title={t(SHORT_MESSAGE_TRANSLATE_TAB.HIDE_SIDEBAR_TOOLTIP.key, SHORT_MESSAGE_TRANSLATE_TAB.HIDE_SIDEBAR_TOOLTIP.value)}>
                  <img src={ExitIcon} alt="exit" />
                  <Icon type="left" />
                </Tooltip>
              </SidebarCloseMenu>
            )}
            {tabIndex === 0 && (
              <ShortMessageTemplates isBottom={isBottom} />
            )}
            {tabIndex === 5 && (
              <SettingsTabDetails
                templates={template}
                isRefElement={false}
                isEmailTemp={false}
                isShortMessageTemp={true}
                onTemplateSave={this.props.onTemplateSave}
              />
            )}
            {tabIndex === 8 && (
              <TranslateMessages
                allLanguages={allLanguages}
                isEmail={false}
                isShortMessageTemplate={true}
                templateId={templateId}
                groupId={groupId}
                language={language}
              />
            )}
            <AppStoreContext.Consumer>
              {appStoreContext => {
                const uniqueDocVar = appStoreContext.documentVariables.reduce((acc, variable) => {
                  if (!acc.includes(variable.variableId)) return [...acc, variable.variableId];
                  return acc;
                }, []);
                const usedVariables = appStoreContext.globalVariables
                  ? uniqueDocVar.map(usedVariable => {
                      return appStoreContext.globalVariables.find(
                        variable => variable.id === parseInt(usedVariable, 10),
                      );
                    })
                  : [];
                return <>{tabIndex === 9 && <VariablesList documentVariables={usedVariables} />}</>;
              }}
            </AppStoreContext.Consumer>
            {tabIndex === 21 && <ChannelTab currentId={templateId} currentType={'short_message'} categoryId={categoryId} resourceGroupId={resourceGroupId} shortMsgGroupId={communicationId} />}
          </TabExpandContainer>
        </SideBarContent>
      </Container>
    );
  }
}

export default withTranslation(NAMESPACES)(SidebarMenu);
